<script>
import { HomeIcon, UserIcon, KeyIcon } from "vue-feather-icons";
import appConfig from "@/app.config";
import axios from 'axios';

// 초기세팅
function initialState() {
  return {
    member: {
      id: "",
      pw: "",
    }
  };
}


export default {
  data() {
    return {
      appConfig: appConfig,
      ...initialState(),
    };
  },
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
  },
  metaInfo() {
    return {
      title: '관리자 로그인 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터 관리자 로그인 페이지입니다.'
        },
        {
          property: 'og:title',
          content: '관리자 로그인 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터 관리자 로그인 페이지입니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '관리자 로그인 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터 관리자 로그인 페이지입니다.'
        }
      ]
    }
  },
  methods: {
    // 초기화
    resetWindow: function (){
      Object.assign(this.$data, initialState());
    },
    // 로그인 버튼 검증
    submit_login() {
      // 모든 칸 채워진건지 확인
      if (this.member.id !=='' && this.member.pw !=='') {
        this.r_member_login()
      } else {
        this.$notify({ type: 'error', duration: 2000, title: '실패', text: '모든 칸을 채워주세요' })
      }
    },
    // 로그인 실행
    r_member_login() {
      try {
        axios({
          method: 'POST',
          url: appConfig.fastapi + '/auth/r_member_login',
          data: {
            "mb_id": this.member.id,
            "mb_pw": this.member.pw,
          },
        })
        .then((res) => {
          if (res.data.status == 'success') {
            this.$store.commit("setAuthIdx", res.data.idx)
            this.$store.commit("setAuthAccessToken", res.data.access_token)
            this.$store.commit("setAuthNick", res.data.nick)
            this.$store.commit("setAuthLevel", res.data.level)
            this.$store.commit("setAuthEmail", res.data.email)
            this.$store.commit("setAuthIsLogin", true)
            // 로컬스토리지에 저장
            const myToken = {
              idx: res.data.idx,
              nick: res.data.nick,
              level: res.data.level,
              email: res.data.email,
              token: res.data.access_token,
              expire: Date.now() + 1 * 60 * 60 * 1000 // 2시간동안 로그인 유지
            };
            localStorage.setItem('user', JSON.stringify(myToken)); // 로컬스토리지에 저장
            //this.$router.go(-1); // 로그인하면 뒤로보내기
            this.$router.push({ path: '/os'})
          } else {
            this.$notify({ type: 'error', duration: 3000, 'title': res.data.status+' 에러', text: res.data.detail })
          }
        })
        .catch((error) => {
          console.log(error)
          if (error.response) {
            this.$notify({ type: 'error', duration: 3000, 'title': error.response.status+' 에러', text: error.response.data.detail })
          }
        })
      } catch (error) {
        this.$notify({ type: 'error', duration: 3000, title: '실패', text: error+'요청 중 에러 발생 관리자에게 문의' })
      }
    },
  }
};
</script>

<template>
  <div>
    <div class="back-to-home rounded d-none d-sm-block">
      <router-link to="/" class="btn btn-icon btn-primary">
        <home-icon class="icons"></home-icon>
      </router-link>
    </div>

    <!-- Hero Start -->
    <section class="bg-derc-member navwave-2 d-flex align-items-center ">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-md-6">
            <div class="media features p-4 bg-primary rounded mr-lg-5">
              <router-link class="logo-footer" to="/">
                <div class="text-bold text-white">
                  <img :src="`${appConfig.url}/images/_decen/logo/logo_old.png`" width="24" alt="" />대구여성인권센터
                </div>
                <div>
                  <span><i class="mdi mdi-shield-account img-fluid mx-auto d-block member-login-img mover text-primary"></i></span>
                </div>
              </router-link>
            </div>
          </div>
          <div class="col-lg-5 col-md-6">
            <div class="card login-page bg-white shadow rounded border-0">
              <div class="card-body">
                <h4 class="card-title text-center text-bold text-primary">관리자 로그인</h4>
                <div class="login-form mt-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="id">아이디 <span class="text-danger">*</span></label>
                        <div class="position-relative">
                          <user-icon class="fea icon-sm icons"></user-icon>
                          <input
                            type="text"
                            class="form-control pl-5"
                            placeholder="아이디를 적어주세요"
                            v-model="member.id"
                            name="id"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="password">비밀번호 <span class="text-danger">*</span></label>
                        <div class="position-relative">
                          <key-icon class="fea icon-sm icons"></key-icon>
                          <input
                            type="password"
                            class="form-control pl-5"
                            v-model="member.pw"
                            @keydown.enter="submit_login()"
                            placeholder="비밀번호를 적어주세요"
                            required=""
                          />
                        </div>
                      </div>
                    </div>

                    <div class="col-lg-12">
                      <div class="d-flex justify-content-between">
                        <div class="form-group">
                          <div class="custom-control custom-checkbox">
                            
                          </div>
                        </div>
                        <!--
                        <p class="forgot-pass mb-0">
                          <router-link
                            to="/member-password"
                            class="text-dark font-weight-bold"
                            >아이디/비밀번호 찾기</router-link
                          >
                        </p>
                        -->
                      </div>
                    </div>
                    <div class="col-lg-12 mb-0">
                      <button @click="submit_login()" class="btn btn-primary btn-block">로그인</button>
                    </div>
                    
                    <!--end col-->
                    <div class="col-12 text-center">
                      <p class="mb-0 mt-3">
                        <small class="text-dark mr-2">승인 후 가입이 완료됩니다</small>
                        <router-link to="/member-signup" class="text-primary font-weight-bold">가입하기</router-link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
